interface Logger {
  log: (...messages: string[]) => void;
  dir: (item: unknown) => void;
}

/* eslint no-console: ["error", { allow: ["log", "dir"] }] */

export function createLogger(debug: boolean | undefined): Logger {
  return {
    log: (...messages: string[]) => {
      return debug
        ? console.log(...["[user-management]:"].concat(messages))
        : undefined;
    },
    dir: (item: unknown) => {
      return debug ? console.dir(item) : undefined;
    },
  };
}
